var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detail-views" }, [
    _c(
      "div",
      { staticClass: "main-content" },
      [
        _c(
          "div",
          { staticClass: "btn-wrapper" },
          [
            _c(
              "el-button",
              { attrs: { type: "success" }, on: { click: _vm.saveSopSet } },
              [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: { click: _vm.handleCloseSopSet }
              },
              [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
            )
          ],
          1
        ),
        _c(
          "el-tabs",
          {
            attrs: { type: "card" },
            on: { "tab-click": _vm.handleClick },
            model: {
              value: _vm.activeName,
              callback: function($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName"
            }
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: _vm.$t("Sop.SopReveal"), name: "sopReveal" } },
              [_c("sop-reveal", { ref: "sopReveal" })],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("Sop.SopFilterConditions"),
                  name: "sopFilter"
                }
              },
              [_c("sop-filter", { ref: "sopFilter" })],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }